import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Img, Button } from "arv-reactcomponents";
import { CONTINUE_LOGIN_MESSAGES, Endpoints } from "npmlinks-constants";

@inject("LoginStore")
@observer
class ContinueLogin extends Component {
  constructor(props) {
    super(props);
    this.onLoginClick = this.onLoginClick.bind(this);
  }

  onLoginClick() {
    this.props.LoginStore.setloginModal(true);
  }

  render() {
    const { altMsg } = this.props;
    return (
      <div className="nw-continuelogin-nonloggedin">
        <div className="nw-continuelogin-container">
          <Img
            className="nw-continuelogin-smiley"
            src={Endpoints.sadSmileyImage}
            alt={altMsg}
          />
          <div className="nw-continuelogin-title">
            {CONTINUE_LOGIN_MESSAGES.OOPS}
          </div>
          <div className="nw-continuelogin-logintext">
            {CONTINUE_LOGIN_MESSAGES.NOT_LOGGED_IN}
          </div>
          <Button
            className="nwc-btn-primary nw-continuelogin-loginbtn"
            onClick={this.onLoginClick}
          >
            {CONTINUE_LOGIN_MESSAGES.LOGIN}
          </Button>
        </div>
      </div>
    );
  }
}

ContinueLogin.wrappedComponent.propTypes = {
  altMsg: PropTypes.string.isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ContinueLogin.wrappedComponent,
  component: ContinueLogin,
};

export default ProjectComponent;
